subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  //alert(">cartUpdate event received in custom-cart-pubsub.js");
  const cartItemCount = event?.cartData?.item_count || event?.cartData?.quantity || 0;
    if (cartItemCount < 1) {
      window.location.reload();
    }
    const cartTotal = event?.cartData?.items_subtotal_price 
      ? event.cartData.items_subtotal_price / 100 
      : 0;
    updateFreeShipping(cartTotal);
    setTimeout(() => {
      couponCodeApplyChecking();
      shippingToBeCalculated();
      freeshipingbar();
    }, 1000);
});
function updateFreeShipping(cartTotal) {
  const achivement_message = document.querySelector("#free-shiping-achivement-message");
  const freeShippingThresholdInput = document.querySelector("#free-shipping-threshold-drawer");
  const freeShippingThreshold = freeShippingThresholdInput 
    ? freeShippingThresholdInput.value
    : 90;
  const fill = document.querySelector("#free-shipping-fill");
  const messageBox = document.querySelector("#free-shipping-message");
  if (!fill || !messageBox) return;
  let percent = Math.min((cartTotal / freeShippingThreshold) * 100, 100);
  fill.style.width = percent + "%";
  if (percent < 40) {
    fill.style.background = "#f44336"; // Red
  } else if (percent < 80) {
    fill.style.background = "#ff9800"; // Orange
  } else {
    fill.style.background = "#4caf50"; // Green
  }
  if (cartTotal >= freeShippingThreshold) {
    messageBox.textContent = achivement_message.value;
  } else {
    const remaining = (freeShippingThreshold - cartTotal).toFixed(2);
    messageBox.textContent = `Add $${remaining} more to get Free Shipping.`;
  }
}

window.addEventListener("load", async function () {
  try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const cartTotal = cartData.items_subtotal_price / 100; // convert cents → ₹
    updateFreeShipping(cartTotal);
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
});

async function freeshipingbar(){
   try {
    const response = await fetch("/cart.js");
    const cartData = await response.json();
    const cartTotal = cartData.items_subtotal_price / 100; // convert cents → ₹
    updateFreeShipping(cartTotal); 
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
}